module.exports = __webpack_public_path__ + "static/media/SoybeanGreen.1dea5bc9.svg";